import React, {Component} from "react";
import "bootstrap";
import {Route, Switch} from "react-router-dom";
import queryString from "query-string";
import TransportReqList from "../Forms/TransportReqList";
import AuctionList from "../Forms/AuctionList";
import AuctionItems from "../Forms/AuctionItems";
import ServicesActs from "../Forms/ServicesActs";
import Yard from "../Forms/Yard";
import ServicesActEdit from "../Forms/ServicesActEdit";
import ChangePassword from "../security/ChangePassword";
import Reports from "../Forms/Reports";
import Sandbox from "../Sandbox/Sandbox";
import ApiAccess from "../security/ApiAccess";
import HelpViewer from "../Forms/HelpViewer";

export const commandToRouteMap = {

    WEB_API_ServicesActsEdit: {link: "ServicesActEdit", render: (id) => <ServicesActEdit commandId={id} />},
    WEB_API_ServicesActsEdit2: {link: "ServicesActEdit2", render: (id) => <ServicesActEdit commandId={id} />},

};

export const formObjectToRouteMap = {
    TransportReqList: {link: "Transport", render: (id) => <TransportReqList commandId={id} />},
    AuctionList: {link: "AuctionList", render: (id) => <AuctionList commandId={id} />},
    AuctionItems: {link: "AuctionItems", render: (id) => <AuctionItems commandId={id} />},
    ServicesActs: {link: "ServicesActs", render: (id) => <ServicesActs commandId={id} />},
    Yard: {link: "Yard", render: (id) => <Yard commandId={id} />},
    Reports: {link: "Reports", render: (id) => <Reports commandId={id} />},

    TransportReqList2: {link: "Transport2", render: (id) => <TransportReqList commandId={id} />},
    AuctionList2: {link: "AuctionList2", render: (id) => <AuctionList commandId={id} />},
    AuctionItems2: {link: "AuctionItems2", render: (id) => <AuctionItems commandId={id} />},
    ServicesActs2: {link: "ServicesActs2", render: (id) => <ServicesActs commandId={id} />},
    Yard2: {link: "Yard2", render: (id) => <Yard commandId={id} />},
};

export function getUrlByMenuItem(menuItem, commandParams) {

    if (!(menuItem && menuItem.AppCommand && menuItem.AppCommand.Param1))
        return "";

    const objectName = menuItem.AppCommand.Param1;

    const target = formObjectToRouteMap[objectName];
    if (!target)
        return "";

    const qs = queryString.stringify(commandParams);

    return "/" + target.link + "?" + qs;
}

export function navigateCommand(history, commandName, commandParams) {

    const target = commandToRouteMap[commandName];
    if (!target)
        return;

    const qs = queryString.stringify(commandParams);

    history.push("/" + target.link + "?" + qs);
}

class Routes extends Component {

    componentWillUnmount() {
        console.log("router unmount");
    }

    render() {
        return (
            <Switch>
                <Route path="/Sandbox" component={Sandbox} />
                <Route path="/">
                    <React.Fragment>
                        {
                            Object.entries(commandToRouteMap)
                                .map(([key, value]) => <Route path={"/" + value.link} key={key} render={function () {
                                    return value.render(key)
                                }}/>)
                        }
                        {
                            Object.entries(formObjectToRouteMap)
                              .map(([key, value]) => <Route path={"/" + value.link} key={key} render={function () {
                                  return value.render(key)
                              }}/>)
                        }
                        <Route path="/ChangePassword" render={() => <ChangePassword/>} />
                        <Route path="/ApiAccess" render={() => <ApiAccess/>} />
                        <Route path="/ApiHelp" render={() => <HelpViewer/>} />
                    </React.Fragment>
                </Route>
            </Switch>
        );
    }
}

export default Routes;
